export default "<p>Validating user.......</p>\r\n";